angular.module('mx.components').directive('mxAttachments', [
	function mxAttachmentsDirective() {
		return {
			link: function (scope, element) {
				const vm = scope.vm;

				if (vm.multiUpload !== false) {
					return;
				}

				element[0].addEventListener('drop', onDrop, true);

				scope.$on('$destroy', function cleanUp() {
					element[0].removeEventListener('drop', onDrop);
				});

				function onDrop() {
					if (vm.files.length) {
						vm.onDelete({ file: vm.files[0] });
					}
				}
			},
			restrict: 'E',
			scope: {},
			bindToController: {
				files: '=',
				headers: '=',
				makeUploadUrl: '&',
				uploadFile: '&',
				formatUrl: '&',
				onDelete: '&',
				onComment: '&',
				onUploadCanceled: '&',
				onUploadCanceling: '&',
				onGetFileUrl: '&',
				readOnly: '=',
				lazyMode: '=?',
				enableSelection: '@',
				type: '@?',
				width: '@?',
				height: '@?',
				maxWidth: '@?',
				maxHeight: '@?',
				default: '@?',
				skipInitialLoad: '=?',
				multiUpload: '=?',
				loadFiles: '&?',
				onDownloadFiles: '&',
				disableSearch: '<',
				disableSort: '<',
				defaultViewMode: '@viewMode',
				storageInfo: '<',
				ignoreFileLimitations: '<',
				settingsInitialized: '<',
				allowedFileTypes: '<',
				fileLimitsMessage: '<',
			},
			require: {
				mxContainerCtrl: '?^^mxContainer',
			},
			controller: MxAttachmentsCtrl,
			controllerAs: 'vm',
			templateUrl: function (tElem, tAttrs) {
				return 'mx-attachments/' + (tAttrs.type === 'image' ? 'mx-image-template.html' : 'mx-attachments.html');
			},
		};
	},
]);

MxAttachmentsCtrl.$inject = [
	'$element',
	'$scope',
	'$timeout',
	'mx.shell.Config',
	'mx.shell.NotificationService',
	'mx.internationalization',
	'mx.SolutionBuilderAgent.PersonalizationService',
	'mx.shell.EventService',
];

function MxAttachmentsCtrl($element, $scope, $timeout, mxConfig, mxNotificationService, i18n, personalizationService, eventService) {
	const vm = this;
	let types;
	let dz;
	vm.i18nCommon = i18n.get('solutionBuilderAgent.common');
	vm.i18n = i18n.get('components.mx-attachments');

	vm.$onInit = function () {
		vm.scope = $scope;
		if (vm.mxContainerCtrl) {
			vm.mxContainerCtrl.registerChild($scope);
		}
		vm.maxCountExceedFiles = [];
		vm.wrongTypeFiles = [];
		vm.maxSizeExceedFiles = [];
		vm.viewMode = vm.defaultViewMode;
		vm.isInitMode = (vm.lazyMode || '').toString().toLowerCase() === 'true';
		if (typeof vm.multiUpload === 'undefined') {
			vm.multiUpload = true;
		}
		vm.onClick = onClick;
		types = loadTypes();
		vm.sortFields = loadSortFields();
		vm.sortBy = vm.sortFields[0].field;
		dz = new mx.components.DropZone($timeout, vm);

		$scope.$watchGroup(['vm.maxCountExceedFiles', 'vm.wrongTypeFiles', 'vm.maxSizeExceedFiles'], showFailedUploadNotifications);
		vm.filesSelected = dz.processSelectedFiles;
		vm.onAdd = onAdd;
		vm.checkSelectionChanges = checkSelectionChanges;
		vm.downloadSelectedLabel = vm.i18n.downloadSelected;
		vm.downloadAllLabel = vm.i18n.downloadAll;
		vm.onDownloadSelected = onDownloadSelected;
		vm.onDownloadAll = onDownloadAll;
		vm.setViewMode = setViewMode;
		vm.onSortingChanged = onSortingChanged;

		vm._files = [];
		setFiles(vm.files);

		Object.defineProperty(vm, 'files', {
			get: () => vm._files,
			set: (value) => {
				setFiles(value);
			},
		});
		if (!vm.readOnly) {
			dz.init($element.find('.mx-attachments-list')[0]);
		}

		initPersonalization();
		let unbindWatcher = $scope.$watch('vm.settingsInitialized', function () {
			if (vm.settingsInitialized) {
				calculateFileLimitsInfoBoxExpandable();
				unbindWatcher();
			}
		});
	};

	$scope.$watch('vm.files.length', function () {
		checkSelectionChanges();
	});

	return vm;

	function initPersonalization() {
		personalizationService.getAttachmentsSettings().then((settings) => {
			if (!settings) {
				return;
			}
			vm.viewMode = settings.viewMode || vm.viewMode;
			vm.sortBy = settings.sortBy || vm.sortBy;
		});
	}

	function setViewMode(viewMode) {
		vm.viewMode = viewMode;
		personalizationService.saveAttachmentsViewMode(viewMode);
	}

	function onSortingChanged(sortBy) {
		personalizationService.saveAttachmentsSorting(sortBy);
	}

	function onAdd($files, $event) {
		vm.onDelete({ file: vm.files[0] });

		$timeout(function () {
			vm.filesSelected($files, $event);
		});
	}

	function onClick() {
		vm.isInitMode = false;

		if ((!vm.files || !vm.files.length) && typeof vm.loadFiles === 'function') {
			vm.loadFiles();
		}
	}

	function checkSelectionChanges() {
		vm.enabledDownloadFiles = vm.files && Array.isArray(vm.files) && vm.files.some((file) => file.selected);
	}

	async function onDownloadSelected() {
		const selectedFiles = vm.files.filter((file) => file.selected);
		await downloadFiles(selectedFiles);
	}

	async function onDownloadAll() {
		await downloadFiles(vm.files);
	}

	async function downloadFiles(files) {
		if (typeof vm.onDownloadFiles === 'function' && Array.isArray(files) && files.length > 0) {
			await vm.onDownloadFiles({ files: files });
		}
	}

	function setFiles(files) {
		vm._files = (files || []).map(function (file) {
			file.type = vm.type === 'image' && file.isVirtual ? 'image' : getType(file);

			if (file.thumbnail) {
				return file;
			}
			const forceThumbnailDrawing = !vm.skipInitialLoad && (/api\/filestorage\//i.test(file.url) || Boolean(file.providerId));

			if (forceThumbnailDrawing) {
				if (vm.type === 'image') {
					delete file.thumbnail;
					dz.createThumbnail(file);
				}
			} else {
				const url = file.url || '';
				file.thumbnail = /^https?:\/\//.test(url) || file.url.startsWith('data:image') ? url : mxConfig.settings.imgHosts.default + url;
				file.type = 'image';
			}
			return file;
		});
	}

	function getType(file) {
		const extension = (file.name.split('.').pop() || '').toUpperCase();
		return types[extension] || 'text';
	}

	function loadTypes() {
		const templates = {};

		['MP4', 'WEBM', 'OGG'].forEach((f) => {
			templates[f] = 'video';
		});

		['JPEG', 'JPG', 'GIF', 'PNG', 'APNG', 'SVG', 'BMP', 'ICO'].forEach((f) => {
			templates[f] = 'image';
		});

		templates.PDF = 'pdf';
		return templates;
	}

	function loadSortFields() {
		return [
			{
				name: vm.i18nCommon.name,
				field: 'name',
			},
			{
				name: vm.i18nCommon.uploaded,
				field: 'uploadedOn',
			},
			{
				name: vm.i18nCommon.size,
				field: 'size',
			},
		];
	}

	function showFailedUploadNotifications() {
		if (vm.maxCountExceedFiles.length === 0 && vm.wrongTypeFiles.length === 0 && vm.maxSizeExceedFiles.length === 0) {
			return;
		}

		let messages = [];

		if (vm.maxCountExceedFiles.length > 0) {
			let maxCountExceedFiles = vm.maxCountExceedFiles.map((x) => x.name);
			let message =
				i18n.getFormatted('components.mx-attachments.filesExceededMaxCountPerObjectErrorMessage', maxCountExceedFiles.length) +
				'<br />' +
				maxCountExceedFiles.join('<br />');
			messages.push(message);
		}
		if (vm.maxSizeExceedFiles.length > 0) {
			let maxSizeExceedFiles = vm.maxSizeExceedFiles.map((x) => x.name);
			let message = i18n.getFormatted('components.mx-attachments.filesExceededSizeErrorMessage', maxSizeExceedFiles.length) + '<br />' + maxSizeExceedFiles.join('<br />');
			messages.push(message);
		}
		if (vm.wrongTypeFiles.length > 0) {
			let wrongTypeFiles = vm.wrongTypeFiles.map((x) => x.name);
			let message =
				i18n.getFormatted('components.mx-attachments.filesNotAllowedTypeErrorMessage', wrongTypeFiles.length, vm.storageInfo.fileExtensions) +
				'<br />' +
				wrongTypeFiles.join('<br />');
			messages.push(message);
		}

		mxNotificationService.alert(vm.i18n.upload, messages.join('<br /><br />'));
	}

	function calculateFileLimitsInfoBoxExpandable() {
		if (!vm.fileLimitsMessage || vm.readOnly) {
			return;
		}

		eventService.subscribeTo(mx.shell.EventCodes.LayoutChanged, recalculateFileLimitsInfoBoxExpandable, $scope);

		$scope.$evalAsync(function () {
			vm.fileLimitMessageBox = $element.find('.mx-attachments-info-box--message')[0];
			recalculateFileLimitsInfoBoxExpandable();
		});
	}

	function recalculateFileLimitsInfoBoxExpandable() {
		vm.expandable = vm.fileLimitMessageBox.offsetWidth < vm.fileLimitMessageBox.scrollWidth;
	}
}
